import * as React from "react"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"

export const SelectField: React.FC<{
  label: string
  options: any[]
  id: string
  setState: any
  state: any
  name: string
  required?: boolean
  placeholder?: string
  error?: string
}> = ({ ...props }) => {
  const {
    label,
    options,
    id,
    setState,
    state,
    name,
    required,
    placeholder,
    error
  } = props

  const handleChange = (event: any) => {
    const value = event.target.value

    if (name.includes(".")) {
      const [parent, child] = name.split(".")

      setState({
        ...state,
        [parent]: {
          ...state[parent],
          [child]: value,
        }
      })
    } else {
      setState({
        ...state,
        [name]: value
      })
    }
  }

  const getCurrentValue = () => {
    if (name.includes(".")) {
      const [parent, child] = name.split(".")
      return state[parent]?.[child] || ""
    }

    return state[name] || ""
  }

  return (
    <div>
      <label
        style={{
          fontSize: 16,
          fontWeight: "bold",
          color: "#332E1A",
          margin: "0px"
        }}
      >
        {label}

        {required && (
          <span style={{ color: "red" }}> *</span>
        )}
      </label>

      <br />

      <Select
        id={`input-select-${id}`}
        style={{ width: "100%", backgroundColor: "white", borderRadius: "5px" }}

        value={getCurrentValue()}
        onChange={handleChange}
        required={required}
        displayEmpty
      >
        <MenuItem value=""
          disabled>
          {placeholder}
        </MenuItem>

        {options.map((option: any, index: number) => (
          <MenuItem
            key={option.value}
            value={option.value}
            id={`option-${index}`}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>

      {error && (
        <span
          style={{
            color: "#FF0000",
            fontSize: "10px"
          }}
        >
          {error}
        </span>
      )}
    </div>
  )
}